/* pd-win-refund — countdown 显示 + 多 instance 安全。
   timer 在 closure 内部，per-instance；不挂 window 避免覆盖。 */
(function () {
  'use strict';
  if (window.customElements.get('pd-win-refund')) return;

  class PdWinRefund extends HTMLElement {
    connectedCallback() {
      if (this._inited) return;
      this._inited = true;

      var endStr = this.getAttribute('data-end');
      if (!endStr) return;
      var end = new Date(endStr).getTime();
      if (isNaN(end)) return;
      var tiles = this.querySelectorAll('[data-pd-countdown] [data-unit]');
      if (!tiles.length) return;

      function pad(n) { return n < 10 ? '0' + n : '' + n; }
      var self = this;
      this._timer = null;
      this._tick = function () {
        var diff = Math.max(0, end - Date.now());
        var s = Math.floor(diff / 1000);
        var d = Math.floor(s / 86400); s = s % 86400;
        var h = Math.floor(s / 3600); s = s % 3600;
        var m = Math.floor(s / 60); s = s % 60;
        var map = { days: d, hours: h, minutes: m, seconds: s };
        tiles.forEach(function (el) {
          var u = el.getAttribute('data-unit');
          if (map[u] != null) el.textContent = pad(map[u]);
        });
        if (diff <= 0 && self._timer) { clearInterval(self._timer); self._timer = null; }
      };
      this._tick();
      this._timer = setInterval(this._tick, 1000);
    }

    disconnectedCallback() {
      if (this._timer) { clearInterval(this._timer); this._timer = null; }
    }
  }

  window.customElements.define('pd-win-refund', PdWinRefund);
})();
